import { FullScreenLoadingSpinner } from '@/components/full-screen-loading-spinner';
import { BlogCard } from '../blog-card';
import type { BlogPageDataResponse } from '@/services/cms/getBlogContent/schemas';

interface BlogGridProps {
  blogPostList: BlogPageDataResponse[];
  isFetching?: boolean;
}

const BlogGrid = ({ blogPostList, isFetching = false }: BlogGridProps) => {
  return (
    <>
      <div className="grid justify-center grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {blogPostList.map((blogData) => (
          <BlogCard
            className="md:h-full"
            key={blogData.id}
            blogCardData={blogData}
          />
        ))}
      </div>
      {isFetching && <FullScreenLoadingSpinner />}
    </>
  );
};

export default BlogGrid;
